import { InPageMessage } from '@liveauctioneers/caterwaul-components/lib/InPageMessage/InPageMessage';
import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { Close } from '@liveauctioneers/hammer-ui-core/icons';
import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getBrowserMajorVersion, getBrowserName } from '@/redux/modules/browser';
import { getCookie, setCookie } from '@/redux/modules/cookies';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

const COOKIE_MAX_AGE = 86400 * 30; // 30 days
const COOKIE_NAME = 'dismissableOutdatedBrowserBanner';
const COOKIE_BODY = 'dismissed';

export const BrowserOutdatedBanner = () => {
    const formatMessage = useAppFormatMessage();
    const dispatch = useAppDispatch();
    const majorVersion = useAppSelector(getBrowserMajorVersion);
    const name = useAppSelector(getBrowserName);

    const hasDismissedCookie = useAppSelector((state) => getCookie(state, COOKIE_NAME)) === COOKIE_BODY;
    const handleSetCookie = useCallback((): void => {
        dispatch(
            setCookie({
                maxAge: COOKIE_MAX_AGE,
                name: COOKIE_NAME,
                value: COOKIE_BODY,
            })
        );
    }, [dispatch]);

    if (hasDismissedCookie) {
        return null;
    }

    return (
        <InPageMessage
            className="browserIsOutdated items-center justify-center [&>div]:grow-0"
            type="warning"
        >
            <div className="relative pr-lg">
                {formatMessage(['did_you_know_that_your_web_browser'], { values: { formalName: name, majorVersion } })}
                <br />
                {formatMessage(['browsers_for_best_experience'], {
                    values: {
                        chrome: 'Google Chrome',
                        edge: 'Microsoft Edge',
                        firefox: 'Mozilla Firefox',
                        safari: 'Apple Safari',
                    },
                })}

                <IconButton
                    className="absolute right-0 top-0"
                    icon={Close}
                    onClick={handleSetCookie}
                    size="sm"
                    variant="transparent"
                />
            </div>
        </InPageMessage>
    );
};
